import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vanxuan/project/vanxuan/web-user/src/components/service/Index.jsx");
